import { FontAwesomeIcon } from "@nef/core"
import React, { MouseEvent } from "react"

import { dateFormatForDisplay } from "../../utils/datetimehandler"
import { IInstrumentSearch } from "../../types/InstrumentExpense"
import { MODAL_ACCESS_TYPES } from "../../types/_enums"
import { sortColumn } from "../../utils/common"

const nonViewColumns = (onDeleteExpenseClick: Function, onEditExpenseClick: Function, onViewExpenseClick: Function) => {
  return [
    {
      Header: "Delete",
      width: "60",
      Cell: ({ cell }: any) => {
        const { original } = cell.row
        return (
          <FontAwesomeIcon
            style={{ fontSize: "14px", cursor: "pointer", color: "crimson" }}
            iconSetClassName="fas"
            iconClassName="fa-trash"
            onClick={() => onDeleteExpenseClick(original)}
            data-testid="editBtn"
          />
        )
      }
    } ,
    {
      Header: "Edit",
      width: "50",
      Cell: ({ cell }: any) => {
        const { original } = cell.row
        return <FontAwesomeIcon style={{ fontSize: "14px", cursor: "pointer" }} iconClassName="fa-pen" onClick={() => onEditExpenseClick(original)} />
      }
    },
    {
      Header: "View",
      width: "50",
      Cell: ({ cell }: any) => {
        const { original } = cell.row
        return <FontAwesomeIcon style={{ fontSize: "14px", cursor: "pointer" }} iconClassName="fa-eye" onClick={() => onViewExpenseClick(original)} />
      }
    }
  ]
}

const columns = (
  applicationMode: `${MODAL_ACCESS_TYPES}`,
  onDeleteExpenseClick: Function,
  onEditExpenseClick: Function,
  onViewExpenseClick: Function
) => {
  return applicationMode === MODAL_ACCESS_TYPES.VIEW ? [...nonViewColumns(onDeleteExpenseClick, onEditExpenseClick, onViewExpenseClick)].slice(2,3) : [...nonViewColumns(onDeleteExpenseClick, onEditExpenseClick, onViewExpenseClick)]
}

export const expenseManagerColumns = (applicationType : `${MODAL_ACCESS_TYPES}`, onDeleteExpenseClick: Function, onEditExpenseClick: Function, onViewExpenseClick : Function) => {
  return [
    ...columns(applicationType, onDeleteExpenseClick, onEditExpenseClick, onViewExpenseClick),
    {
      Header: "Symbol",
      accessor: (data: any) => {
        return data.symbol
      }
    },

    {
      Header: "Management Fees",
      accessor: (data: any) => {
        return data.managementFees
      }
    },
    {
      Header: "Account / 12b-1 Fees",
      accessor: (data: any) => {
        return data.account12b1Fees
      }
    },

    {
      Header: "Other Expenses",
      accessor: (data: any) => {
        return data.otherExpenses
      }
    },
    {
      Header: "Total Expense Ratio",
      accessor: (data: any) => {
        return data.totalExpenseRatio
      }
    },
    {
      Header: "Front Load",
      accessor: (data: any) => {
        return data.frontLoad
      }
    },
    {
      Header: "Level Load",
      accessor: (data: any) => {
        return data.levelLoad
      }
    },
    {
      Header: "Deferred Load",
      accessor: (data: any) => {
        return data.deferredLoad
      }
    },
    {
      Header: "Redemption Fee",
      accessor: (data: any) => {
        return data.redemptionFee
      }
    },
    {
      Header: "Expense As Of Date",
      sortType: (rowA: any, rowB: any) => sortColumn(rowA, rowB, "expenseAsOfDate"),
      accessor: (data: any) => {
        return dateFormatForDisplay(data.expenseAsOfDate)
      }
    },
    {
      Header: "Net Expense Ratio",
      accessor: (data: any) => {
        return data.netExpenseRatio
      }
    },
    {
      Header: "Minimal Annual Fee",
      accessor: (data: any) => {
        return data.minAnnualFee
      }
    },
    {
      Header: "Minimal Annual Fee Currency",
      accessor: (data: any) => {
        return data.minAnnualCurrencyIso
      }
    }
  ]
}

export const instrumentSearchColumns = () => {
  return [
    {
      Header: "Symbol",
      width: "70",
      accessor: (data: IInstrumentSearch) => {
        return <span style={{ cursor: "pointer" }}>{data.symbol}</span>
      }
    },
    {
      Header: "Instrument Name",
      width: "200",
      accessor: (data: IInstrumentSearch) => {
        return data.instrumentName || "-"
      }
    },
    {
      Header: "Status",
      width: "60",
      accessor: (data: IInstrumentSearch) => {
        return data.status
      }
    },
    {
      Header: "NSM",
      width: "80",
      accessor: (data: IInstrumentSearch) => {
        return data.nsm
      }
    },
    {
      Header: "Effective Date",
      width: "80",
      sortType: (rowA: any, rowB: any) => sortColumn(rowA, rowB, "effectiveDate"),
      accessor: (data: IInstrumentSearch) => {
        return dateFormatForDisplay(data.effectiveDate)
      }
    },
    {
      Header: "CUSIP",
      width: "60",
      accessor: (data: IInstrumentSearch) => {
        return data.cusip || "-"
      }
    },
    {
      Header: "ISIN",
      width: "70",
      accessor: (data: IInstrumentSearch) => {
        return data.isin || "-"
      }
    }
  ]
}
